import { clsx } from 'clsx';

import { ServerErrorIcon } from '../../components/svg/ServerErrorIcon';
import { iwocapayTelDisplay, iwocapayTelLink } from '../../constants.json';

export const GenericError = ({
  name,
  errorText,
  className,
}: {
  name?: string;
  errorText: string;
  className?: string;
}) => {
  return (
    <div className={clsx('relative text-center', className)}>
      <div className="mx-auto max-w-[650px] p-[37px] text-denim-15">
        <div className="mb-[20px] text-center text-[32px] font-bold leading-[normal]">
          Sorry, {name} {errorText}
        </div>
        <div className="mx-auto max-w-[436px] text-center text-m font-med leading-[150%]">
          Please give us a call on{' '}
          <a
            href={iwocapayTelLink}
            className="inline cursor-pointer font-bold text-denim-15 underline"
          >
            {iwocapayTelDisplay}
          </a>
        </div>
      </div>
      <ServerErrorIcon className="mx-auto mb-[10px] h-auto w-[18rem] m800:mt-[50px] m800:w-[20rem]" />
    </div>
  );
};
